import { styled, Box } from '@mui/material';

export const ButtonContainer = styled(Box)`
  margin-left: auto;
  align-self: self-start;
`;
